module.exports = __webpack_public_path__ + "img/1.b44a693.png";